import * as ng from 'angular';

class CancelSubscriptionModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    'store',
    '$timeout',
    '$uibModalStack',
    '$uibModal',
    'configuration',
    '$sce'
  ];

  private close: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private configuration: any,
    private $sce: ng.ISCEService
  ) {

    $scope.confirm = false;
    $scope.save = () => {
      this.close({$value: true});
    };
    $scope.cancel = () => {
      this.close({$value: false});
    };
  }
}

export const CancelSubscriptionModalComponent: ng.IComponentOptions = {
  template: require('./cancel-subscription-modal.html'),
  controller: CancelSubscriptionModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/cancel-subscription-modal/cancel-subscription-modal.ts